var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/home_add.bfcd6e8f.png","uri@2x": __webpack_public_path__ + "static/media/home_add.a9e8ae30.png","uri@3x": __webpack_public_path__ + "static/media/home_add.ef52d949.png",
    width: 32,
    height: 32
});